jQuery(function($) {
    initFancyList();
    marketTestimonials();
    caseStudyTestimonials()
    postsTestimonials();

    function initFancyList() {
        var $main_list = $('.market-detail-template .main-content ol');

        if ($main_list != undefined) {
            var $inner_list = $('.market-detail-template .main-content ol li > ol');
            var $arrow = $('.market-detail-template .main-content ol > li ');
            $inner_list.hide();

            $arrow.click(function() {
                $(this).find('ol').slideToggle();
                $(this).toggleClass('opened');
            });
        }
        else {
            return;
        }
    }

    function marketTestimonials() {
        var $testimonials = $('.market-detail-template .testimonials .testimonials_container .testimonials_wrapper');

        if ($testimonials != undefined) {
            $testimonials.slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: true,
                fade: true,
                adaptiveHeight: true
            });
        }
    }

    function caseStudyTestimonials() {
        var $testimonials = $('.case-study-detail-template .testimonials .testimonials_container .testimonials_wrapper');
        
        if ($testimonials != undefined) {
            $testimonials.slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: true,
                fade: true,
                adaptiveHeight: true
            });
        }
    }

    function postsTestimonials() {
        var $testimonials = $('.posts-testimonials-slider .fl-post-feed');

        if ($testimonials != undefined) {
            $testimonials.slick({
                dots: true,
                arrows: true,
                infinite: true,
                speed: 300,
                slidesToShow: 1,
                centerMode: true,
                fade: true,
                adaptiveHeight: true
            });
        }
    }

});

jQuery(function($) {

  initSiteSearch();

  function initSiteSearch() {
    $('.open-search').on('click', function() {
      var $content = $('.hidden-modal--search .search-form');

      setTimeout(function () {
        $.magnificPopup.open({
          removalDelay: 0,
          closeBtnInside: true,
          showCloseBtn: true,
          overflowY: 'scroll',
          mainClass: 'modal__wrapper',
          items: {
            src: $content
          },
          type: 'inline'
        });
      }, 100);

      return false;
    });
  }

});
